import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

/**
 * Provider para gerenciar o tema (dark/light mode) e sidebar globalmente
 */
export function ThemeProvider({ children }) {
  // Inicializa com o valor salvo no localStorage ou default para dark
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem('sideb-theme');
    return saved !== null ? saved === 'dark' : true;
  });

  // Estado do sidebar colapsado
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem('sideb-sidebar-collapsed');
    return saved === 'true';
  });

  // Persiste a preferencia de tema no localStorage
  useEffect(() => {
    localStorage.setItem('sideb-theme', darkMode ? 'dark' : 'light');
    // Espelha o tema na classe do <html>. O Tailwind está configurado com
    // `darkMode: 'class'`, então as telas escritas com as variantes `dark:`
    // (Frequência de Funcionários, Relatórios) só escurecem com esta classe.
    document.documentElement.classList.toggle('dark', darkMode);
  }, [darkMode]);

  // Persiste o estado do sidebar no localStorage
  useEffect(() => {
    localStorage.setItem('sideb-sidebar-collapsed', sidebarCollapsed);
  }, [sidebarCollapsed]);

  const toggleTheme = () => setDarkMode(prev => !prev);
  const toggleSidebar = () => setSidebarCollapsed(prev => !prev);

  const value = {
    darkMode,
    setDarkMode,
    toggleTheme,
    sidebarCollapsed,
    setSidebarCollapsed,
    toggleSidebar,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

/**
 * Hook para acessar o contexto de tema
 */
export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme deve ser usado dentro de um ThemeProvider');
  }
  return context;
}

export default ThemeContext;
